<template>
  <!-- 度量衡组建 -->
  <div :class="{'measure-wrap': true, 'milti-measure-wrap': props.type === 'multi_value_measure'}">
    <el-form :inline="true" class="measure-form">
      <template v-for="template in templateValueList">
        <div :key="template.templateId" class="measure-item">
          <template v-for="(measure, mIndex) in template.measureList">
            <div :key="template.templateId + mIndex" style="display: inline-block; margin-right: 30px; margin-bottom: 10px">
              <template v-for="(vm, index) in measure.values">
                <el-form-item :key="template.templateId + vm.moduleId + index">
                  <span v-if="vm.prefix"> {{ vm.prefix }}</span>
                  <el-select
                    v-if="['enum_diy', 'enum'].includes(vm.inputType)"
                    :allow-create="vm.inputType === 'enum_diy'"
                    filterable
                    v-model="vm.value"
                    style="width: 100px"
                  >
                    <el-option v-for="ops in vm.values || []" :key="ops.valueName" :label="ops.valueName" :value="ops.valueName" />
                  </el-select>
                  <el-input-digit
                    v-else-if="vm.inputType === 'input' && vm.validateRule.dataType === 'float'"
                    v-model.number="vm.value"
                    :precision="vm.validateRule.precision"
                    :max="vm.validateRule.max"
                    :min="vm.validateRule.min"
                    style="width: 80px"
                  >
                    <span v-if="(!vm.units || !vm.units.length) && vm.unit_id"> {{ vm.unit_id }}</span>
                  </el-input-digit>
                  <el-date-picker
                    v-else-if="vm.inputType === 'input' && vm.validateRule.dataType === 'date'"
                    v-model="vm.value"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    style="width: 140px !important"
                  />
                  <el-input v-else v-model="vm.value" style="width: 80px" />
                  <span v-if="vm.units && vm.units.length" class="suffix-wrap">
                    <el-select v-model="vm.unit_id" style="width: 60px" @change="val => unitChange(val, vm)">
                      <el-option v-for="ut in vm.units || []" :key="ut.unitId" :label="ut.unitName" :value="ut.unitId" />
                    </el-select>
                  </span>
                  <span v-if="vm.suffix"> {{ vm.suffix }}</span>
                </el-form-item>
              </template>
              <i class="el-icon-delete" v-if="props.type === 'multi_value_measure'" style="cursor: pointer;" @click="deleteItem(template.measureList, mIndex)"></i>
            </div>
          </template>
          <template v-if="props.type === 'multi_value_measure'">
            <MaterialAutoParse @confirm="parseList => confirmMaterial(parseList, template.measureList, template.templateId)" />
            <el-button @click="addItem(template.measureList, template.templateId)" style="margin-left: 10px;"> + 添加材质</el-button>
          </template>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import MaterialAutoParse from '@/components/prod/center/BasicComps/MaterialAutoParse.vue';
import { cloneDeep } from 'lodash';
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: ['props', 'value'],
  components: {
    MaterialAutoParse,
  },
  data() {
    return {
      templateValueList: [],
    };
  },
  watch: {
    props: {
      handler(v) {
        const measureTemplates = cloneDeep(v.measureTemplates || []);
        const templateValueList = [];
        measureTemplates.forEach(mt => {
          let measureList = [];
          let tempValues = this.value?.filter(v => v.measure_info?.template_id === mt.templateId);
          const valueModules = mt.valueModules || [];
          if (!tempValues?.length) {
            const vvalues = valueModules.map(vm => {
              return {
                module_id: vm.moduleId,
                unit_name: '',
                prefix: vm.prefix || '',
                suffix: vm.suffix || '',
                value: '',
                unit_id: '',
              };
            });
            tempValues = [
              {
                measure_info: {
                  values: vvalues,
                  template_id: mt.templateId,
                },
              },
            ];
          }
          tempValues.forEach(tv => {
            let measureItem = [];
            valueModules.forEach(vm => {
              const mInfoItem = tv.measure_info.values.find(tmi => tmi.module_id === vm.moduleId);
              let valueItem = {
                ...vm,
                ...mInfoItem,
                suffix: vm.suffix || '',
                prefix: vm.prefix || '',
              }
              if(!valueItem.unit_id && valueItem.units[0]) {
                valueItem.unit_id = valueItem.units[0].unitId
                valueItem.unit_name = valueItem.units[0].unitName
              }
              measureItem.push(valueItem);
            });
            measureList.push({
              propertyName: v.propertyName,
              name: '',
              diy_type: v.diyType,
              value: 0,
              propertyId: v.propertyId,
              values: measureItem,
            });
          });
          templateValueList.push({ templateId: mt.templateId, measureList });
        });
        this.$set(this, 'templateValueList', templateValueList);
      },
      immediate: true,
    },
    templateValueList: {
      handler(list) {
        let valueList = [];
        list.forEach(t => {
          t.measureList.forEach(measure => {
            const isTrue = measure.values.every(v => {
              if (v.units?.length) {
                return v.value && v.unit_name;
              } else {
                return v.value;
              }
            });
            if (isTrue) {
              let concatName = '';
              const values = measure.values.map(v => {
                concatName += v.prefix;
                concatName += v.value;
                concatName += v.unit_name || '';
                concatName += v.suffix;
                return {
                  unit_name: v.unit_name,
                  module_id: v.module_id || v.moduleId,
                  prefix: v.prefix,
                  suffix: v.suffix,
                  value: String(v.value),
                  unit_id: v.unit_id || 0,
                };
              });
              valueList.push({
                propertyName: measure.propertyName,
                value: measure.value || 0,
                diy_type: measure.diy_type,
                propertyId: measure.propertyId,
                name: concatName,
                measure_info: {
                  values,
                  template_id: t.templateId,
                },
              });
            }
          });
        });
        this.$emit('change', valueList);
      },
      deep: true,
      immediate: true
    },
  },
  computed: {},
  methods: {
    unitChange(val, vm) {
      const fUnit = vm.units.find(unit => unit.unitId == val) || {};
      vm.unit_name = fUnit.unitName;
    },
    addItem(measureList, templateId, valueItem) {
      const measureTemplates = cloneDeep(this.props.measureTemplates || []);
      const findMt = measureTemplates.find(mt => mt.templateId === templateId);
      const values = findMt.valueModules.map(vm => {
        const firstUnit = vm?.units[0] || {}
        let value = ''
        if(valueItem) {
          if(['enum_diy', 'enum'].includes(vm.inputType)) {
            let findOp = vm.values.find(v => v.valueName === valueItem.valueName)
            if(!findOp) {
              findOp = vm.values.find(v => v.valueName.includes(valueItem.valueName) || valueItem.valueName.includes(v.valueName))
            }
            if(!findOp && 'enum_diy' !== vm.inoutType) {
              value = ''
            } else {
              value = valueItem.valueName || ''
            }
          } else if(vm.inputType === 'input' && vm.validateRule?.dataType === 'float') {
            value = valueItem.percentageValue || ''
          } else {
            value = valueItem.valueName || ''
          }
        }
        return {
          module_id: vm.moduleId,
          unit_name: firstUnit.unitName || '',
          prefix: '',
          suffix: '',
          value,
          unit_id: firstUnit.unitId || '',
          ...vm,
        };
      });
      measureList.push({
        propertyName: this.props.propertyName,
        name: '',
        diy_type: this.props.diyType,
        value: '',
        propertyId: this.props.propertyId,
        values,
      });
    },
    deleteItem(measureList, mIndex) {
      measureList.splice(mIndex, 1);
    },
    confirmMaterial(parsedList, measureList, templateId) {
      measureList.splice(0);
      parsedList.forEach(item => {
        this.addItem(measureList, templateId, item);
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.measure-wrap {
  display: inline-block;
  width: 100%;
 ::v-deep input.el-input__inner {
    border-radius: 0;
  }
  ::v-deep .el-input-digit .suffix {
    right: 0;
  }
}
.milti-measure-wrap {
  // margin-top: 25px;
  display:inline-block;
  width:100%;
 
  .measure-item {
    padding: 10px; 
    border: 1px solid #ccc
  }

  .suffix-wrap {
    display: inline-block;
    ::v-deep .el-select .el-input__inner {
      border-left: none;
    }
  }
  .measure-form .el-form-item {
    margin-right: 4px;
  }
}
</style>
